import React from 'react';
import { makeStyles, MenuList, MenuItem, Typography, Drawer } from '@material-ui/core';
import User from '../model/User';
//icons
import AccountIcon from '@material-ui/icons/AccountCircle';
const useStyles = makeStyles(theme => ({
    drawer: {
        width: 240,
        flexShrink: 0,
    },

    toolbar: theme.mixins.toolbar,
    list: {
        width: 250,
    },
    hide: {
        display: 'none',
    },
    header: {
        height: theme.spacing(24),
        background: theme.palette.primary.main,
        display: 'flex',
        flexDirection: 'column',
        color: "#FFF",
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    accountIcon: {
        padding: 0,
        marginLeft: theme.spacing(-1),
        marginBottom: theme.spacing(1),
        height: theme.spacing(8),
        width: theme.spacing(8),
    },
    headerSpace: {
        flexGrow: 1,
    },
    appInfo: {
        marginTop: theme.spacing(1),
    }
}));

const AppDrawer: React.FC<{ state: boolean, onClose: () => void }> = (props) => {
    const user = new User();
    const classes = useStyles();
    return (
        <Drawer open={props.state} onClose={() => props.onClose()}>
            <div className={classes.list} role="presentation"
            >  <div className={classes.header} >
                    <div className={classes.headerSpace} />
                    <AccountIcon className={classes.accountIcon} />
                    <Typography variant="body1">SmartAPK: {user.subjectId}</Typography>
                </div>
                <MenuList>
                    <MenuItem onClick={() => window.location.href = '#/about'} >О приложении</MenuItem>
                    <MenuItem onClick={() => {
                        if (window.confirm("id пользователя: " + user.userId + "\nВыйти из аккаунта?")) {
                            user.singOut();
                            window.location.reload();
                        }
                    }} >Выйти из аккаунта</MenuItem>
                </MenuList>
                {/* 
                        <Divider />
                    */}
            </div >
        </Drawer >
    );
}
export default AppDrawer;
